import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon, FlameIcon, GiftIcon, ArrowRightIcon, TicketIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE } from '../data/hero';
import { bonuses, idealFor, offerIncludes } from '../data/system';
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="scroll-mt-12 bg-obsidian text-white" data-id="element-187" data-mp="25t95ra7vrehl">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "21px"
    }} data-id="element-188" data-mp="20s3c9a6ebn70">
        <div className="mx-auto max-w-xl text-center" data-id="element-189" data-mp="3h5tionkzmnjt">
          <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/40 bg-ember/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-ember" data-id="element-190" data-mp="3c8jufb9c4hxk">
            <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-191" data-mp="3w1t7hufwuz6n" /> Limited offer — ending soon
          </p>
          
          <p className="mt-4 text-[15px] leading-relaxed text-white/65" data-id="element-192" data-mp="9si87x0pwf0m">
            The price will return to $54 USD after the current launch offer. This launch price will not
            remain available indefinitely.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 overflow-hidden rounded-3xl border border-white/10 bg-navy shadow-[0_40px_80px_-40px_rgba(20,125,255,0.45)] lg:grid lg:grid-cols-[1fr_1.05fr]" data-id="element-193" data-mp="3daijbl1kl0ig">
          <div className="border-b border-white/10 p-6 sm:p-8 lg:border-b-0 lg:border-r" style={{
          paddingTop: "0px"
        }} data-id="element-194" data-mp="2uhoe3itr0mrf">
            
            <h3 className="mt-6 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-195" data-mp="2zf7t4ky9t3kf">
              The Full Distance Triathlon System™
            </h3>
            <p className="mt-6 text-xs font-bold uppercase tracking-[0.22em] text-aqua" data-id="element-196" data-mp="2mh06n3ufwupi">Ideal for</p>
            <ul className="mt-3 space-y-2.5" data-id="element-197" data-mp="3164sqw4cvj2w">
              {idealFor.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-white/75" data-id="element-198" data-mp="2w7bdoz9f7k0m">
                  <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-199" data-mp="28h7dl1vfy2ed" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="p-6 sm:p-8" data-id="element-200" data-mp="2igpsv50ep003">
            <div className="flex items-end gap-3" data-id="element-201" data-mp="2ihrgsa2itgz8">
              <span className="font-display text-[84px] font-extrabold leading-[0.8]" data-id="element-202" data-mp="2dhd5mj5mhqwz">$27</span>
              <span className="pb-1 text-lg font-bold text-white/80" data-id="element-203" data-mp="3tv3d7zvyaxbd">USD</span>
              <span className="pb-1 text-xl font-medium text-white/35 line-through" data-id="element-204" data-mp="3tx6ddcqti6tt">$54</span>
            </div>
            <p className="mt-4 text-xs font-semibold text-white/70" data-id="element-205" data-mp="adjsn3fbnhf">One-time payment · Lifetime access</p>
            <p className="mt-1 text-[11px] text-white/45" data-id="element-206" data-mp="596z8l29tok8">The payment will be processed in your local currency.</p>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-207" data-mp="3nfl9oa1bzgdv">
              Your complete system includes
            </p>
            <ul className="mt-3 grid gap-x-4 gap-y-2 sm:grid-cols-2" data-id="element-208" data-mp="3riredd8sozi8">
              {offerIncludes.map(f => <li key={f} className="flex items-start gap-2 text-sm leading-snug text-white/85" data-id="element-209" data-mp="j1n47reqfwns">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-perf" strokeWidth={3} aria-hidden="true" data-id="element-210" data-mp="nz6n54mdkxm2" />
                  {f}
                </li>)}
            </ul>

            <p className="mt-7 text-xs font-bold uppercase tracking-[0.22em] text-white/50" data-id="element-211" data-mp="e8u27banf2fe">
              Plus 4 free performance tools
            </p>
            <ul className="mt-3 divide-y divide-white/10 border-y border-white/10" data-id="element-212" data-mp="16qfvvbobnicl">
              {bonuses.map(b => <li key={b.n} className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-213" data-mp="3f7ihfyy4dgjt">
                  <span className="flex min-w-0 items-center gap-2 text-white/85" data-id="element-214" data-mp="3a8fh2rt33yi6">
                    <GiftIcon className="h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-215" data-mp="3aas61ox9f94q" />
                    <span className="truncate" data-id="element-216" data-mp="35bfamfsbotqj">{b.title.replace(/^The /, '')}</span>
                  </span>
                  <span className="whitespace-nowrap text-xs" data-id="element-217" data-mp="31a3r8s01l4qs">
                    <span className="text-white/35 line-through" data-id="element-218" data-mp="1s453ijx0cu9">{b.price}</span>{' '}
                    <span className="font-bold text-perf" data-id="element-219" data-mp="3szyjawfab8j5">FREE</span>
                  </span>
                </li>)}
            </ul>

            <p className="mt-5 flex items-center gap-2 rounded-xl border border-perf/25 bg-perf/10 px-4 py-3 text-sm font-semibold text-white" data-id="element-220" data-mp="3o63z7rvrorjj">
              <ShieldCheckIcon className="h-5 w-5 shrink-0 text-perf" aria-hidden="true" data-id="element-221" data-mp="kjn8hqhupswt" />
              7-Day Money-Back Guarantee
            </p>

            <div className="mt-6" data-id="element-222" data-mp="fr3u4rbcatqy">
              <CTAButton className="max-w-none" data-id="element-223" data-mp="1yfeppwstil3n">Get instant access</CTAButton>
            </div>
            <p className="mt-3 text-center text-xs font-semibold text-perf" data-id="element-224" data-mp="23e82fn0a682r">
              You save $27 USD · Limited launch price
            </p>

            <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-225" data-mp="27f1veuskyd2i">
              {trust.map(({
              icon: Icon,
              label
            }) => <li key={label} className="inline-flex items-center gap-1.5" data-id="element-226" data-mp="2he94h5sa7ljt">
                  <Icon className="h-4 w-4 text-aqua" aria-hidden="true" data-id="element-227" data-mp="2hc6gsselq4i9" />
                  {label}
                </li>)}
            </ul>

            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-ember" data-id="element-228" data-mp="2r3kauknsac40">
              <TicketIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-229" data-mp="2v4cl9h8e6n1v" /> Limited availability at this price
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}